'use strict';
import logger from "../../apps/root/assets/js/logger";
import {SignupHelper} from "../../apps/root/assets/js/signup-helper";

let Signup = (() => {

	let theForm = document.querySelector('form.reg--form');
	SignupHelper.theForm = theForm;
	const passVisibilityIcons = theForm.querySelectorAll('.box .password--visibility');

	const controlDaysWithMonths = () => SignupHelper.controlDaysWithMonths();
	const controlDaysWithYear = () => SignupHelper.controlDaysWithYear();
	const controlEmail = async () => await SignupHelper.controlEmail(theForm.querySelector('.box input[name=email]'));
	const controlUsername = () => SignupHelper.controlUsername(theForm.querySelector('.box input[name=login]'));
	const controlPassword = () => SignupHelper.controlPassword(theForm.querySelector('.box input[name=password]'));
	const controlFirstName = () => SignupHelper.controlFirstName(theForm.querySelector('.box input[name=first_name]'));
	const controlLastName = () => SignupHelper.controlLastName(theForm.querySelector('.box input[name=last_name]'));
	const controlBirthday = () => SignupHelper.controlBirthday(theForm.querySelectorAll('#BirthMonthSelect, #BirthDaySelect, #BirthYearSelect'));
	const controlPassVisibility = () => SignupHelper.controlPassVisibility(passVisibilityIcons);
	const controlCurrency = () => SignupHelper.controlCurrency(theForm.querySelector('#currency_id'));
	const controlFocus = () => SignupHelper.controlFocus(theForm.querySelectorAll('.box input:not([type="checkbox"]):not([type=radio])'));
	const toggleForm = (removeMsgs = true) => SignupHelper.toggleForm(removeMsgs);

	const submit = (e) => {
		e.preventDefault();
		// disable form inputs
		if (!toggleForm()) return;

		let thisForm = e.target;
		let data = new FormData(thisForm);
		for (let pair of data.entries()) {
			logger.log(pair[0] + ', ' + pair[1]);
		}
		SignupHelper.doFetch('quicksignup', data, "https://bonusblitz.com", "bb");
	}

	return {
		theForm,
		submit,
		controlFocus,
		controlPassVisibility,
		controlUsername,
		controlEmail,
		controlPassword,
		controlFirstName,
		controlLastName,
		controlBirthday,
		controlCurrency,
		controlDaysWithMonths,
		controlDaysWithYear
	}

})();

Signup.controlFocus();
Signup.controlUsername();
Signup.controlEmail().then(r => {});
Signup.controlPassword();
Signup.controlFirstName();
Signup.controlLastName();
Signup.controlBirthday();
Signup.controlCurrency();
Signup.controlDaysWithMonths();
Signup.controlDaysWithYear();
Signup.controlPassVisibility();
Signup.theForm.addEventListener('submit', (e) => Signup.submit(e));

